import { Reveal, Overline } from "./Reveal";
import { JOURNEY } from "../../data/content";

export const Journey = () => {
  return (
    <section id="journey" data-testid="journey-section" className="relative py-28 lg:py-40 bg-ink">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8">
        <div className="mb-16 max-w-2xl">
          <Reveal><Overline>The Journey</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter">
              A timeline of <span className="text-gold-gradient italic">faith & fire</span>
            </h2>
          </Reveal>
        </div>

        <div className="relative border-l border-gold/25 ml-3 lg:ml-6">
          {JOURNEY.map((j, i) => (
            <Reveal key={j.year + j.title} delay={i * 0.04}>
              <div className="relative pl-8 lg:pl-14 pb-14 last:pb-0 group">
                <span className="absolute -left-[7px] top-1.5 w-3 h-3 rounded-full bg-ink border border-gold group-hover:bg-gold transition-colors duration-500" />
                <div className="flex flex-col lg:flex-row lg:items-baseline gap-2 lg:gap-8">
                  <span className="font-serif text-2xl lg:text-3xl text-gold/80 w-40 shrink-0">{j.year}</span>
                  <div>
                    <h3 className="font-serif text-2xl lg:text-3xl font-light tracking-tight">{j.title}</h3>
                    <p className="mt-2 text-white/55 leading-relaxed max-w-xl">{j.body}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
